import { FileText } from 'lucide-react';
import { Badge } from '../ui/Badge';
import { EmptyState } from '../ui/EmptyState';
import { formatRelativeTime } from '../../utils/format';
import type { WordPressPost } from '../../types';

const statusTone: Record<string, 'success' | 'warning' | 'neutral'> = {
  publish: 'success',
  future: 'warning',
  draft: 'neutral',
  pending: 'warning',
};

export function RecentPostsList({ posts }: { posts: WordPressPost[] }) {
  if (posts.length === 0) {
    return <EmptyState icon={FileText} title="No recent posts" />;
  }

  return (
    <ul className="divide-y divide-slate-100 dark:divide-slate-800">
      {posts.map((post) => (
        <li key={post.id} className="flex items-center gap-3 py-3">
          <div className="min-w-0 flex-1">
            <a
              href={post.link}
              target="_blank"
              rel="noreferrer"
              className="block truncate text-sm font-medium text-slate-800 hover:text-pulse-600 dark:text-slate-200 dark:hover:text-pulse-400"
            >
              {post.title}
            </a>
            <p className="mt-0.5 text-xs text-slate-400">
              {post.authorName} &middot; updated {formatRelativeTime(post.modifiedAt)}
            </p>
          </div>
          <Badge tone={statusTone[post.status] ?? 'neutral'}>{post.status}</Badge>
        </li>
      ))}
    </ul>
  );
}
